import * as Yup from 'yup'

export const DEFAULT_MIN_PASSWORD_LENGTH = 8

export const MAX_PASSWORD_LENGTH = 72

export const passwordHelperText = (minLength: number = DEFAULT_MIN_PASSWORD_LENGTH): string =>
  `Your password must be at least ${minLength} characters.`

export const passwordMaxLengthText = `Your password must be ${MAX_PASSWORD_LENGTH} characters or fewer.`

export const passwordYupShape = (minLength: number = DEFAULT_MIN_PASSWORD_LENGTH) => ({
  pass: Yup.string()
    .min(minLength, passwordHelperText(minLength))
    .max(MAX_PASSWORD_LENGTH, passwordMaxLengthText)
    .required(passwordHelperText(minLength)),
  passConfirm: Yup.string()
    .oneOf([Yup.ref('pass')], 'Your passwords must match.')
    .required('Your passwords must match.'),
})
